export const DAYS = [
  { day: 0, name: "Mon" },
  { day: 1, name: "Tue" },
  { day: 2, name: "Wed" },
  { day: 3, name: "Thu" },
  { day: 4, name: "Fri" },
  { day: 5, name: "Sat" },
  { day: 6, name: "Sun" }
];
